import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'pinnedModules';

@Injectable({ providedIn: 'root' })
export class PinnedModulesService {
  readonly pinnedRoutes = signal<string[]>(this.load());

  pin(route: string): void {
    if (this.pinnedRoutes().includes(route)) return;
    this.pinnedRoutes.set([...this.pinnedRoutes(), route]);
    this.save();
  }

  unpin(route: string): void {
    this.pinnedRoutes.set(this.pinnedRoutes().filter((r) => r !== route));
    this.save();
  }

  toggle(route: string): void {
    if (this.isPinned(route)) {
      this.unpin(route);
    } else {
      this.pin(route);
    }
  }

  isPinned(route: string): boolean {
    return this.pinnedRoutes().includes(route);
  }

  private load(): string[] {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  private save(): void {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(this.pinnedRoutes()),
    );
  }
}
